import { Action } from 'models/Action';
import { Model } from 'react3l-common';
import { Field } from 'react3l-decorators';

export class DocumentPermissionFieldMapping extends Model {
    @Field(Number)
    public documentPermissionId?: number;

    @Field(Number)
    public actionId?: number;

    public action?: Action;
}
